import { render, staticRenderFns } from "./BlackThreePrize.vue?vue&type=template&id=533a7133&scoped=true&"
import script from "./BlackThreePrize.vue?vue&type=script&lang=js&"
export * from "./BlackThreePrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackThreePrize.vue?vue&type=style&index=0&id=533a7133&prod&lang=less&scoped=true&"
import style1 from "./BlackThreePrize.vue?vue&type=style&index=1&id=533a7133&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a7133",
  null
  
)

export default component.exports